// open?id= opens files and folders alike, so every Drive list shares one link shape.
export const driveOpenUrl = (id: string) =>
  `https://drive.google.com/open?id=${encodeURIComponent(id)}`;
